export default {
	noEvents: "Nenhum evento encontrado",
	noEventsDescription: "Não há eventos para exibir nesta timeline",
};
